<template>
  <div class="fixed backdrop pin z-30 overflow-y-auto" @click.stop="$emit('leave')">
    <div class="flex items-center justify-center min-h-screen">
      <div :class="mainClass" :style="{width}" @click.stop>
        <div
          v-if="showCloseBtn"
          class="bg-white absolute pin-t pin-r md:-mt-3 md:-mr-3 rounded-full p-2 shadow cursor-pointer z-10"
          @click.stop.prevent="$emit('leave')"
        >
          <icon name="delete" class="w-5 h-5" :center="false" />
        </div>

        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  data () {
    return {
      defaultClass: 'bg-white rounded-lg shadow-lg p-6 relative my-6 max-w-lg min-w-1/2'
    }
  },
  computed: {
    mainClass: function () {
      if (this.modalClass) {
        if (this.modalClass.length > 0) {
          return this.modalClass
        } else {
          return this.defaultClass
        }
      } else {
        return this.defaultClass
      }
    }
  },

  props: {
    width: { type: String },
    height: { type: String },
    modalClass: { type: String },
    showCloseBtn: { type: Boolean },
    scrollY: { type: Boolean, default: true }
  },
  created () {
    document.body.classList.add('overflow-hidden')
  },
  beforeDestroy () {
    document.body.classList.remove('overflow-hidden')
  }
}
</script>

<style lang="scss" scoped>
  .backdrop {
    background: rgba(0,0,0,.5)
  }
</style>
